<template>
  <div id="data-view">
    <dv-full-screen-container style="width: 100%; height: 100%">
      <!-- 头部标题 -->
      <header-title />
      <div class="main-content">
        <!-- 头部数据汇总 -->
        <data-summary :summaryData="countData.total" />
        <div class="block-left-right-content">
          <!-- 智能烘房 -->
          <drying-room />
          <div class="block-top-bottom-content">
            <div class="block-top-content">
              <!-- 视频展示 -->
              <dv-border-box-10 class="dvBorderVideo">
                <div class="video">
                  <video
                    style="width: 100%; height: 100%"
                    controls
                    autoplay
                    muted
                    loop
                  >
                    <source src="@/assets/video.mp4" type="video/mp4" />
                  </video>
                </div>
                <!-- 奖励公示 -->
                <reward />
              </dv-border-box-10>
              <!-- 库存明细 -->
              <inventory :countData="countData" />
            </div>
            <!-- 各个车间 -->
            <workshop :countData="countData" />
          </div>
        </div>
      </div>
    </dv-full-screen-container>
  </div>
</template>

<script>
import headerTitle from './headerTitle'
import dataSummary from './dataSummary'
import inventory from './inventory'
import workshop from './workshop'
import dryingRoom from './dryingRoom'
import reward from './reward.vue'
import rankingBoard from './rankingBoard'
import roseChart from './roseChart'
import waterLevelChart from './waterLevelChart'

export default {
  name: 'index',
  components: {
    headerTitle,
    dataSummary,
    inventory,
    workshop,
    dryingRoom,
    reward,
    rankingBoard,
    roseChart,
    waterLevelChart
  },
  data() {
    return {
      refreshInterval: null,
      countData: {
        total: {
          employeeCount: 0,
          departmentCount: 0,
          processCount: 0,
          productCount: 0,
          taskCount: 0,
          completedCount: 0,
          smartDeviceCount: 0,
          rawMaterialCount: 0,
          videoCount: 0
        },
        rawMaterialStatistics: [],
        packageRawMaterialStatistics: [],
        packageRawMaterialStockCount: 0,
        packageRawMaterialInCount: 0,
        packageRawMaterialOutCount: 0,
        productStatistics: [],
        productStockCount: 0,
        productTodayInCount: 0,
        productTodayOutCount: 0,
        productionDepartmentStatistics: [
          {
            admin: {
              name: '',
              photo: ''
            },
            departmentEmployeeCount: 0,
            departmentEmployeeWorkCount: 0,
            processList: [],
            semiFinishedProductList: []
          },
          {
            admin: {
              name: '',
              photo: ''
            },
            departmentEmployeeCount: 0,
            departmentEmployeeWorkCount: 0,
            processList: [],
            semiFinishedProductList: []
          },
          {
            admin: {
              name: '',
              photo: ''
            },
            departmentEmployeeCount: 0,
            departmentEmployeeWorkCount: 0,
            processList: [],
            semiFinishedProductList: []
          },
          {
            admin: {
              name: '',
              photo: ''
            },
            departmentEmployeeCount: 0,
            departmentEmployeeWorkCount: 0,
            processList: [],
            semiFinishedProductList: []
          },
          {
            admin: {
              name: '',
              photo: ''
            },
            departmentEmployeeCount: 0,
            departmentEmployeeWorkCount: 0,
            processList: [],
            semiFinishedProductList: []
          }
        ]
      }
    }
  },
  created() {
    // 初始化数据
    this.getData()
    this.startRefreshInterval() // 开始定时刷新
  },
  beforeDestroy() {
    this.stopRefreshInterval() // 清理定时器
  },
  methods: {
    // 数据获取
    getData: function () {
      let that = this
      this.$axios({
        url: 'https://lchp.5any.cn/api/erpAppStatistics/bigData',
        method: 'GET'
      })
        .then(function (response) {
          // console.log(response)
          //监控数量在这里配置
          response.data.result.total.videoCount = 0;
          that.countData = response.data.result
          
        })
        .catch(function (error) {
          alert('请求失败 ' + error)
        })
    },
    startRefreshInterval() {
      this.refreshInterval = setInterval(() => {
        this.getData()
      }, 1000 * 30)
    },
    stopRefreshInterval() {
      if (this.refreshInterval) {
        clearInterval(this.refreshInterval)
      }
    }
  }
}
</script>

<style lang="less">
#data-view {
  width: 100%;
  height: 100%;
  background-color: #030409;
  color: #fff;

  #dv-full-screen-container {
    background-image: url('../../assets/img/bg.png');
    background-size: 100% 100%;
    box-shadow: 0 0 3px blue;
    display: flex;
    flex-direction: column;
  }

  .main-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    .block-left-right-content {
      flex: 1;
      display: flex;
      margin-top: 20px;

      .block-top-bottom-content {
        flex: 1;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        padding-left: 8px;

        .block-top-content {
          height: 55%;
          display: flex;
          flex-grow: 0;
          box-sizing: border-box;
          padding-bottom: 15px;

          .dvBorderVideo {
            width: 50%;
            height: 100%;
            .video {
              margin: 9px 8px 4px;
            }
          }
        }
      }
    }
  }
}
</style>
